module.exports = __webpack_public_path__ + "media/KZ-AKM.c86bc292.ogg";